export default "__VITE_ASSET__DTOJM6BC__"